import { InjectionToken } from '@angular/core';

/**
 * All this library needs from an app's platform service. Public, dashboard and promoter each own a
 * separate `PlatformService`, so importing one would tie every other app to that app's scope.
 */
export interface PostHogPlatform {
  readonly isTrackable: boolean;
}

export const POSTHOG_PLATFORM = new InjectionToken<PostHogPlatform>('POSTHOG_PLATFORM');
